
module.exports = {
  language: {
    name: "ENGLISH"
  },
  header: {
    home: '首页',
    cases: '工程案例',
    equipment: '特色项目',
    technology: '设备技术',
    news: '公司动态',
    about: '关于我们',
    contactus: '联系我们',
    welcome: '欢迎光临~西安惠泽建设工程有限公司',
    Projectsunderconstruction: '在建完建项目',
    company: '西安惠泽建设工程有限公司',
    hometitle: '惠及天下 泽被桑梓'


  },
  home: {
    brief: '公司简介',
    brief_txt1: '西安惠泽建设工程有限公司（简称西安惠泽）成立于2010年6月20日，注册资本2000万元。公司主要从事水利水电工程土石坝沥青混凝土心墙施工。公司具有雄厚的人才技术力量，精良的施工机械设备，先进的施工检测手段与完善的质量保证体系。',
    brief_txt2: '公司现有职工200余人，技术管理人员60人。其中高级职称10人，中级职称50人。公司资产总额达9000万元，大中型施工机械50台套，其中沥青混凝土拌和楼16座，自主研发沥青混凝土心墙和面板联合摊铺机15台。十年来，公司承接沥青防渗工程近80项，形成一支技术过硬、作风优良，善于攻坚克难的施工团队。公司以独特的技术专业优势、丰富的施工经验、雄厚的施工实力、精湛的施工工艺在业内享有极高声誉。',
    brief_txt3: " 公司业务以高新特色施工技术及其应用为主，不断加大对技术开发的投入，在专业化施工道路上取得了丰硕成果。成功完成了重庆玉滩水库、四川去学水电站、新疆石门水电站、西藏恰央水库、吉林敦化抽水蓄能电站上下库等70余座沥青混凝土防渗工程。",
    innovate: '创新',
    innovate_txt: '观念创新，管理创新 技术创新',
    security: '安全',
    security_txt: '安全第一，质量为本',
    quality: '质量',
    quality_txt: '做精品工程，良心工程',
    target: '目标',
    target_txt: '向国内一流专业工程公司 的目标稳步奋进',
    equipment_cases: '工程案例',
    luyu: '鲁班奖',
    Newheight: '新高度',
    chongqing: '鲁班奖-玉滩水库-重庆',
    chongqing_txt1: '公司成立后实施的第一座沥青混凝土心墙项目。玉滩水库位于重庆市大足区境内，总投资达15亿，灌溉面积为32.84万亩，是重庆市境内的一座大二型水库。',
    chongqing_txt2: '玉滩水库枢纽建筑物主要由主坝、副坝、溢洪道及左、右岸灌溉引水隧洞组成。水库工程主坝为沥青心墙石渣坝。',
    chongqing_txt3: '2012年11月玉滩水库枢纽工程获得了中国水利工程优质奖（大禹奖）。',
    newlength: '大方量',
    high_altitude: '耐严寒',
    fastrise: '出国门',
    sichuan: '新技术-去学水电站-四川',
    sichuan_txt: '去学坝是目前世界已建最高的沥青混凝土心墙坝。',
    xinjian: '大方量-苏洼龙水电站-四川',
    xinjian_txt: ' 苏洼龙水电站堆石坝是目前国内沥青混凝土心墙方量最大的土石坝。',
    xizang: '耐严寒-库什塔依水电站-新疆',
    xizang_txt: '  库什塔依水电站大坝为沥青混凝土心墙坝，施工最低环境温度达-15℃以下。',
    lake: '出国门-宗格鲁水库-尼日利亚',
    lake_txt: ' 宗格鲁水库是尼日利亚在建最大水电站，是公司参与施工的海外沥青混凝土心墙坝。',
    dunhua: '新长度-敦化抽水蓄能电站-吉林',
    hexin: '弧心墙-河心水库-重庆',
    qiayang: '高海拔-恰央水库-西藏',
    bulage: '上升快-青河喀英德布拉克水电站-新疆',
    shimen: '速度高-石门水库-新疆',
    axiaoke: '阿克肖水库-新疆',
    batang: '巴塘电站-金沙江上游',
    hongshanxia: '红山下水库-新疆',
    hongyudong: '红鱼洞水库-四川',
    xianghe: '湘河水库-西藏',
    yalong: '雅砻水库-西藏',
    yangjiang: '阳江抽水蓄能电站-广东',


    jishu: '技术交流',

    jishu2: '实验测试',


    cedingyi: '针入度试验器沥青润滑脂针入度测试仪锥入度测定仪',
    cedingyi_txt: '针入度试验器是根据中华人民共和国标准GB/T4509-1998/2010《石油沥青针入度测定法》、GB/T269《润滑脂和石油脂锥入度测定法》及中华人民共和国交通行业标准JTGE20-2011《公路工程沥青及沥青混合料试验规程》中的T0604-2011《沥青针入度试验》中的技术要求和有关规定设计制造的，主要适用于沥青针入度的测试和润滑脂(或石油脂)锥入度的测试。',
    shiyanyi: '沥青软化点测定仪（高温型）沥青软化点试验仪',
    shiyanyi_txt: '时间、温度分别显示，升温速度采用模糊逻辑控制，磁力搅拌器搅拌，升温线性好，红外调制扫描钢球下沉距离(25.4mm)自动存储试验结果。',
    liqing: '沥青延度试验器',
    liqing_txt: '本仪器是根据中华人民共和标准GB/T 4508-2010《石油沥青延度测定法》、中华人民共和行业标准JTG E20-2011《公路工程沥青及沥青混合料试验规程》中的T 0605-2011《沥青延度试验》规定的要求设计的，适用于按GB/T 4508-2010、或T 0605-2011标准所规定的方法测定石油沥青在规定的条件和的温度下以的速度拉伸至断裂时的长度。',
    hunningtu: '沥青混凝土检测',
    tech_1: '原材料检测',
    tech_2: '1.大石   2.中石   3.小石   4.砂   5.填料   6.沥青   7.沥青混凝土',
    tech_3: '室内检测',
    tech_4: ' 根据设计和规范要求，将现场取来的沥青混合料采用马歇尔击实仪成型，并检测其孔隙率。',
    tech_5: '现场检测',
    tech_6: '  现场质量检测分为无损检测和钻芯取样检测。对每层沥青混凝土进行无损检测。',
    tech_7: '力学性能检测',
    tech_8: '沥青混凝土力学性能检测主要包括沥青混凝土静三轴试验、小梁弯曲试验、拉伸试验等。',
    tech_9: '环境保护部召开《重金属污染综合防治“十二五”规划》工作会议',
    tech_10: ' 环境保护部2月18日在京召开《重金属污染综合防治"十二五"规划》视频工作会议。环境保护部部长',
    tech_11: '石门水库工程历时三年顺利完工',
    tech_12: '地处新疆昌吉州呼图壁县的呼图壁河中上游峡谷进口段 ,东距乌鲁木齐市直线距离71ｋｍ ,北距呼',
    tech_13: '2010年5月，重庆玉滩水库扩建工程顺利完工',
    tech_14: '2009年3月到2010年5月施工重庆玉滩水库。玉滩水库扩建工程是拆除原大坝后，在原坝上游',


  },

  cases: {
    cases_1: '去学水电站位于金沙江二级支流硕曲河上，距四川甘孜州得荣县城约40km，距云南香格里拉县城126km。',
    cases_2: '苏洼龙水电站位于金沙江上游河段四川巴塘县和西藏芒康县的界河上，为金沙江上游水电规划13个梯级电站的第10级。',
    cases_3: '库什塔依水电站位于新疆特克斯县境内的特克斯河一级支流库克苏河上，距特克斯县20km,距伊宁市139km。库什塔依水电站大坝为沥青混凝土心墙坝。',
    cases_4: '敦化抽水蓄能电站位于吉林省敦化市北部，与黑龙江省海林市交界。距长春市直线距离220km，距敦化市公路里程111km，距吉林市公路里程280km。',
    cases_5: '河心水库位于重庆市武隆县巷口镇芦红村，距武隆县城21km。大坝采用沥青混凝土心墙堆石坝防渗，坝顶高程1295.20m，坝轴线长137m，最大坝高34m。',
    cases_6: '恰央水库位于西藏日喀则地区岗巴县的那区藏布上，是一座以灌溉为目标的水利工程。恰央水库沥青混凝土心墙坝坝顶长度625.30m，坝顶宽6.00m，最大坝高36.60m。',
    cases_7: '喀英德布拉克位于新疆维吾尔自治区阿勒泰地区青河县，是一座以灌溉为主，兼顾防洪和供水的中型水库。大坝为沥青凝土心墙砂砾石坝，最大坝高59.6m，坝顶长度608m。',
    cases_8: '石门水库位于新疆维吾尔自治区呼图壁县，总库容7751万m3。沥青心墙堆坝最大坝高106m。新疆石门水库高峰期每天4层，沥青心墙最高，月上升18m。',
    cases_9: '宗格鲁水电站尼日利亚在建的最大水电站，电站枢纽由拦河大坝、坝后厂房、变电站等建筑物组成。本项目常态混凝土共约74.7万m3，碾压砼约180万m3',
    cases_10: '2018年中国水利学会面板坝专业委员会在云南省昆明市举办“混凝土面板堆石坝及沥青材料筑坝技术交流会”。会议期间参观公司承建的昆明市东川区轿子山水库施工现场。',
    cases_11: '截止2020年为止，西安惠泽已经在全国各地先后参与七十二座水电站水库承建工作，并且以优良的工程质量和良好的管理制度取得了一致好评。',
    cases_12: '重庆 - 玉滩水库 ( 鲁班奖大禹奖 )',
    cases_13: '去学水电站（ 新高度 ）',
    cases_14: '苏洼龙水电站（ 大方量 ）',
    cases_15: '库什塔依水电站（ 耐严寒 ）',
    cases_16: '敦化抽水蓄能电站（ 新长度 ）',
    cases_17: '河心水库（ 弧心墙 ）',
    cases_18: '恰央水库（ 高海拔 ）',
    cases_19: '喀英德布拉克（ 上升快 ）',
    cases_20: '石门水库（ 速度高 ）',
    cases_21: '尼日利亚-宗格鲁水电站（ 出国门 ）',

    cases_22: '公司成立后实施的第一座沥青混凝土心墙项目。玉滩水库位于重庆市大足区境内，总投资达15亿，灌溉面积为32.84万亩，是重庆市境内的一座大二型水库。玉滩水库扩建工程枢纽由主坝、7座副坝、溢洪道、左右岸灌溉引水隧洞及泵站组成，主坝坝型为沥青混凝土心墙坝，最大坝高42.70m，主坝总长688.20m,水库总库容1.496亿m3设计灌溉面积30.13万亩，年引水总量（P=75%）8264万m3；城乡供水人口59.10万，城乡生活及工业年引水总量6100万m3。<br/>      <span>&nbsp &nbsp &nbsp  &nbsp</span>2012年11月玉滩水库枢纽工程获得了中国水利工程优质奖（大禹奖）。2015年11月玉滩水库枢纽工程获得了中国建设工程鲁班奖。',
    cases_23: '去学水电站位于金沙江二级支流硕曲河上，距四川甘孜州得荣县城约40km，距云南香格里拉县城126km。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>去学水电站沥青混凝土心墙堆石坝坝顶高程为2334.20m，坝顶长219.85m，坝顶宽15m，最大坝高174.2m，心墙最大高度132m，左岸岸坡坡比1:0.33。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>去学坝是目前世界已建最高的沥青混凝土心墙坝。',
    cases_24: '苏洼龙水电站位于金沙江上游河段四川巴塘县和西藏芒康县的界河上，为金沙江上游水电规划13个梯级电站的第10级。坝址距上游巴塘县城约79km，距下游得荣县城约159km；距成都约860km，距昆明约909km。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>水电站沥青混凝土堆石坝坝顶高程2480m，最大坝高112m，坝顶长度464.7m，坝顶宽度12m。沥青混凝土方量为37000m3。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>苏洼龙水电站堆石坝是目前国内沥青混凝土心墙方量最大的土石坝。为实现心墙全面机械化，公司研发第7代沥青心墙联合摊铺机，心墙摊铺宽度可达150cm，是目前国内外沥青心墙摊铺最宽的摊铺机。',
    cases_25: '库什塔依水电站位于新疆特克斯县境内的特克斯河一级支流库克苏河上，距特克斯县20km,距伊宁市139km。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>库什塔依水电站大坝为沥青混凝土心墙坝。最大坝高91.1m,坝顶高程1307.60m,坝顶宽度10m,坝顶长439.0m。电站装机100MW,多年平均发电量3.50亿kW.h。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>沥青混凝土心墙施工最低环境温度达-15℃以下。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>库什塔依电站高峰期每天4层：1-4月完成50m高的围堰心墙，5-11月完成91m高的大坝心墙。',
    cases_26: '敦化抽水蓄能电站位于吉林省敦化市北部，与黑龙江省海林市交界。距长春市直线距离220km，距敦化市公路里程111km，距吉林市公路里程280km。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>电站总装机1400MW，上、下库均为沥青混凝土心墙堆石坝。下库最大坝高68m，坝顶长度730m；上库最大坝高54m，坝顶长度960m。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>公司承建的最长沥青混凝土心墙坝。',
    cases_27: '河心水库位于重庆市武隆县巷口镇芦红村，距武隆县城21km。大坝采用沥青混凝土心墙堆石坝防渗，坝顶高程1295.20m，坝轴线长137m，最大坝高34m。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>工程为中国第一座弧形轴线沥青混凝土心墙坝。',
    cases_28: '恰央水库位于西藏日喀则地区岗巴县的那区藏布上，是一座以灌溉为目标的水利工程。<br>恰央水库沥青混凝土心墙坝坝顶长度625.30m，坝顶宽6.00m，最大坝高36.60m。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>坝址区海拔高程为4700m，是国内海拔最高的沥青混凝土心墙坝。',
    cases_29: '喀英德布拉克位于新疆维吾尔自治区阿勒泰地区青河县，是一座以灌溉为主，兼顾防洪和供水的中型水库。<br>大坝为沥青凝土心墙砂砾石坝，最大坝高59.6m，坝顶长度608m。<br>大坝沥青混凝土心墙最大月上升速度为18m。<br> <span>&nbsp &nbsp &nbsp  &nbsp</span>和公司完成的新疆石门堆石坝沥青混凝土心墙最大月上升速度一样，是目前国内外沥青混凝土心墙上升速度最快的工程。',
    cases_30: '石门水库位于新疆维吾尔自治区呼图壁县，总库容7751万m3。沥青心墙堆坝最大坝高106m。新疆石门水库高峰期每天4层，沥青心墙最高，月上升18m。',
    cases_31: '宗格鲁水电站尼日利亚在建的最大水电站，电站枢纽由拦河大坝、坝后厂房、变电站等建筑物组成。本项目常态混凝土共约74.7万m3，碾压砼约180万m3；主体工程开挖工程量为963万m3，其中土方308万m3，石方655万m3；心墙堆石坝最大坝高50m，沥青混凝土3.4万m3。是公司参与施工的海外沥青混凝土心墙坝。',
    cases_32: '2018年中国水利学会面板坝专业委员会在云南省昆明市举办“混凝土面板堆石坝及沥青材料筑坝技术交流会”。会议期间参观公司承建的昆明市东川区轿子山水库施工现场。',
    cases_101: '石门水库位于新疆维吾尔自治区呼图壁县',
    cases_102: '阿克肖水库工程位于巍昆仑山南麓，新疆和田地区皮山县阿克肖河下游山区河段上，是阿克肖河上唯一的控制性水库，主要任务是承担下游皮山县的灌溉和防洪任务。坝型为沥青混凝土心墙坝，心墙最大坝高近60m。',
    cases_103: '巴塘水电站位于川藏交界的金沙江上游河段，左岸属四川巴塘县，右岸属西藏芒康县，是金沙江上游河段规划的13座梯级电站的第9座梯级水电站。',
    cases_104: '红山下水库项目总投资3.39亿元，设计总库容996万m³，主要由拦河大坝、放水涵洞、导流泄洪冲沙涵洞、溢洪道等建筑物组成。',
    cases_105: '红鱼洞水库距南江县城19公里，坝址处，多年平均来水量2.66亿立方米，水库规划坝高96米，主干渠220公里，总库容1.9亿立方米，是一座以防洪、灌溉为主，兼顾供水、生态、发电等综合效益的大型骨干控制性枢纽工程。',
    cases_106: '湘河工程水库正常蓄水位4099米，总库容1.13亿立方米，电站装机4万千瓦，多年平均发电量1.38亿千瓦时，将有效改善日喀则南木林县及下游沿线12.49万亩农田灌溉，造就日喀则市最大“粮仓”。',
    cases_107: '雅砻水库位于西藏中南部地区，山南地区乃东县境内的雅鲁藏布江右岸一级支流雅砻河上游格曲上。工程距乃东县亚堆乡曲德贡村3km，距山南地区行署所在地泽当镇47Km，距西藏自治区首府驻地拉萨195Km。雅砻水库属Ⅲ等中型工程，总库容为2206万m³。',
    cases_108: '阳江抽水蓄能电站位于广东省阳江市阳春八甲山区，是国家“十三五”水电发展规划中40万千瓦级设备自主化的依托项目。阳江抽水蓄能电站是国内已投运单机容量最大的抽水蓄能电站，机组设计难度位于世界前列。',


  },
  project: {
    address1: '重庆',
    address2: '四川',
    address3: '云南',
    address4: '贵州',
    address5: '甘肃',
    address6: '河南',
    address7: '新疆',
    address8: '西藏',
    address9: '内蒙古',
    address10: '吉林',
    address11: '山西',
    address12: '青海',
    address13: '海南',
    address14: '广西',
    address15: '非洲',
    p1_1: '玉滩水库',
    p1_2: '河心水库',
    p1_3: '金鸡水库',
    p1_4: '王家山水库',
    p1_5: '重庆大足县',
    p1_6: '重庆武隆县',
    p1_7: '重庆忠县',
    p1_8: '重庆丰都县',
    p2_1: '二朗庙水库',
    p2_2: '双桥水库',
    p2_3: '天星桥水库',
    p2_4: '红鱼洞水库',
    p2_5: '后沟水库',
    p2_6: '王家沟水库',
    p2_7: '东山水库',
    p2_8: '蟠龙湖水库',
    p2_9: '三仙湖水库',
    p2_10: '官帽舟水库',
    p2_11: '黄金坪水电站',
    p2_12: '去学水电站',
    p2_13: '苏洼龙电站',
    p2_14: '公墓志水库',
    p2_15: '八角水库',
    p2_16: '象鼻咀水库',
    p2_17: '马鞍山水库',
    p2_18: '双峡湖水库',
    p2_19: '杨家河水库',
    p2_20: '四川通江县',
    p2_21: '四川平昌县',
    p2_22: '四川巴州区',
    p2_23: '四川南江县',
    p2_24: '四川筠连县',
    p2_25: '四川长宁县',
    p2_26: '四川宜宾市',
    p2_27: '四川遂宁市',
    p2_28: '四川马边县',
    p2_29: '四川泸定县',
    p2_30: '四川得荣县',
    p2_31: '四川巴塘县',
    p2_32: '四川什邡市',
    p2_33: '四川威远县',
    p2_34: '四川米易县',
    p2_35: '四川朝天区',
    p2_36: '四川剑阁县',
    p3_1: '轿子山水库',
    p3_2: '天生桥水库',
    p3_3: '小菁沟水库',
    p3_4: '赛京水库',
    p3_5: '东河水库',
    p3_6: '丙果河水库',
    p3_7: '中叶水库',
    p3_8: '铜厂水库',
    p3_9: '云南昆明市',
    p3_10: '云南凤庆县',
    p3_11: '云南凤庆县',
    p3_12: '云南广南县',
    p3_13: '云南巍山县',
    p3_14: '云南镇沅县',
    p3_15: '云南墨江县',
    p3_16: '云南金平县',
    p4_1: '纳达水库',
    p4_2: '者岳水库',
    p4_3: '高普陇水库',
    p4_4: '贵州兴义市',
    p4_5: '贵州册亨县',
    p4_6: '贵州安龙县',
    p5_1: '关峡水库',
    p5_2: '甘肃天水市',
    p6_1: '谷山水库',
    p6_2: '河南安东县',
    p7_1: '克孜加尔水库',
    p7_2: '加那尕什水库',
    p7_3: '喀英德布拉克水库',
    p7_4: '乌拉斯特水库',
    p7_5: '二塘沟水库',
    p7_6: '鱼尔沟水库',
    p7_7: '石门水库',
    p7_8: '水溪沟水库',
    p7_9: '齐古水库',
    p7_10: '红山下水库',
    p7_11: '达克曲克水电站',
    p7_12: '尼雅水库',
    p7_13: '阿克肖水库',
    p7_14: '库什塔依水电站',
    p7_15: '阿克加孜克水库',
    p7_16: '四道白杨沟水库',
    p7_17: '八木墩水库',
    p7_18: '米兰河水库',
    p7_19: '沙尔托海水库',
    p7_20: '托帕水库',
    p7_21: '新疆阿勒泰市',
    p7_22: '新疆哈巴河县',
    p7_23: '新疆青河县',
    p7_24: '新疆阿勒泰市',
    p7_25: '新疆鄯善县',
    p7_26: '新疆托克逊县',
    p7_27: '新疆呼图壁县',
    p7_28: '新疆吉木萨尔县',
    p7_30: '新疆和田县',
    p7_31: '新疆民丰县',
    p7_32: '新疆皮山县',
    p7_33: '新疆特克斯县',
    p7_34: '新疆巩留县',
    p7_35: '新疆伊吾县',
    p7_36: '新疆哈密市',
    p7_37: '新疆若羌县',
    p7_38: '新疆精河县',
    p7_39: '新疆乌恰县',


    p8_1: '雅砻水库',
    p8_2: '卓于水库',
    p8_3: '恰央水库',
    p8_4: '湘河水库',
    p8_5: '扎仓嘎水库',
    p8_6: '西藏乃东县',
    p8_7: '西藏扎囊县',
    p8_8: '西藏岗巴县',
    p8_9: '西藏南木林县',
    p8_10: '西藏芒康县',


    p9_1: '隆胜水库',
    p9_2: '红格尔水库',
    p9_3: '东台子水库',
    p9_4: '内蒙古卓资县',
    p9_5: '内蒙古四子王旗',
    p9_6: '内蒙古林西县',

    p10_1: '敦化抽水蓄能电站上库',
    p10_2: '敦化抽水蓄能电站下库',
    p10_3: '吉林敦化市',

    p11_1: '西汤水库',
    p11_2: '瓦舍水库',
    p11_3: '山西沁县',
    p11_4: '山西垣曲县',

    p12_1: '尕干水库',
    p12_2: '青海同德县',

    p13_1: '琼中抽水蓄能电站',
    p13_2: '海南琼中县',

    p14_1: '驮英水库',
    p14_2: '广西宁明县',

    p15_1: '宗格鲁水电站',
    p15_2: '非洲尼日利亚',




  },
  equipment: {
    equip1: '针入度试验器',
    equip1_txt: '针入度试验器是根据中华人民共和国标准GB/T4509-1998/2010《石油沥青针入度测定法》、GB/T269《润滑脂和石油脂锥入度测定法》及中华人民共和国交通行业标准JTGE20-2011《公路工程沥青及沥青混合料试验规程》中的T0604-2011《沥青针入度试验》中的技术要求和有关规定设计制造的，主要适用于沥青针入度的测试和润滑脂(或石油脂)锥入度的测试。',
    equip2: '马歇尔自动击实仪',
    equip2_txt: '马歇尔电动击实仪是沥青混合料马歇尔试验中试件成型的专用设备，适用于沥青混合料马歇尔试验（JTJ/E20  -2011）标准。仪器由机械传动与控制仪表二部分组成，机械传动机构为电机、减速机、链条驱动。具有实时时钟、环境温度检测显示，并配有常用按钮方便日常操作。',
    equip3: '溶剂法沥青含量分析仪',
    equip3_txt: '本设备适用于离心分离法测定粘稠石油沥青拌制的沥青混合料中沥青含量(或油石比)，适用于调查时检测沥青及沥青混合料的沥青用量。',
    equip4: '沥青软化点测定仪',
    equip4_txt: ' 时间、温度分别显示，升温速度采用模糊逻辑控制，磁力搅拌器搅拌，升温线性好，红外调制扫描钢球下沉距离(25.4mm)自动存储试验结果。',
    equip5: '马歇尔稳定度试验仪',
    equip5_txt: '本仪器是根据国家行业标准JTJ052《公路工程沥青及沥青混合料试验规程》中的《沥青混合料马歇尔稳定度试验》规定的要求设计制造，适用于沥青混合料的马歇尔稳定度试验，能够准确地判断沥青混合料的破坏点，以进行沥青混合料的配合比设计或施工质量检验。',
    equip6: '沥青混凝土动静三轴试验仪',
    equip6_txt: ' 主机设计为刚性加载框架，可以完成单轴状态下和三轴状态下的强度试验、松弛试验、蠕变试验等；三轴状态下的高、低温试验，孔隙水压试验；单轴状态下试件的间接拉伸试验和直接拉伸试验；检测出试件的抗压强度，泊松比、弹模、剪切强度、空隙水渗透指数等参数。试验结束后，设备根据实验内容画出应力-应变全过程曲线，及其它各种相关参数曲线。全部试验过程都是在计算机控制下进行的，具有很高的自动化程度。',
    equip7: '沥青延度试验器',
    equip7_txt: '本仪器是根据中华人民共和标准GB/T 4508-2010《石油沥青延度测定法》、中华人民共和行业标准JTG E20-2011《公路工程沥青及沥青混合料试验规程》中的T0605-2011《沥青延度试验》规定的要求设计的，适用于按GB/T4508-2010、或T0605-2011标准所规定的方法测定石油沥青在规定的条件和的温度下以的速度拉伸至断裂时的长度。',
    equip8: '燃烧法沥青含量分析仪',
    equip8_txt: ' 燃烧法沥青含量分析仪，仪器主要测定沥青混合料中沥青的含量同时也为级配分析提供干净的骨料。',
    equip9: '沥青路面无核密度仪',
    equip9_txt: '沥青路面无核密度仪采用电磁法测量沥青路面的均匀性和相对密度，并自动计算平均密度、压实度和孔隙率，该测量易于发现沥青混凝土的不均匀性，离析和低密度区，在每层沥青混凝土碾压完成后检测沥青混凝土密度，及时发现问题。'
  },
  technology: {
    tec1: '原材料',
    tec1_txt: ' 沥青混凝土由骨料（大石、中石、小石、砂），填料，沥青组成。粗骨料宜采用碱性岩石破碎加工，细骨料可采用人工砂和天然砂，填料宜采用石灰岩、大理岩、白云岩等岩石加工，沥青品种和标号应根据设计要求通过试验确定。',
    tec2_txt: ' 根据设计和规范要求，将现场取来的沥青混合料采用马歇尔击实仪成型，并检测其孔隙率。必要时，对马歇尔试件进行渗透等性能检测。',
    tec3_txt: ' 沥青混合料抽提试验采取溶剂法或燃烧法进行，确定沥青混合料中配合比。',
    tec4_txt: ' 现场质量检测分为无损检测和钻芯取样检测。 对每层沥青混凝土进行无损检测。无损检测采用无核密度仪和渗气仪，检测沥青混凝土的容重（孔隙率）和渗透性。',
    tec5_txt: '沥青混凝土心墙每上升一定高度，按设计和规范要求应进行钻芯取样，检测容重、孔隙率、渗透系数、力学性能等',
    tec6_txt: ' 沥青混凝土力学性能检测主要包括沥青混凝土静三轴试验、小梁弯曲试验、拉伸试验等。',
    tec7_txt: '通过小梁弯曲试验得到沥青混凝土抗弯强度、最大弯拉应变、弯曲模量、挠跨比。',
    tec8_txt: '通过三轴试验仪对沥青混凝土试件进行试验，得到沥青混凝土芯样的粘聚力C，内摩擦角φ，模量数K等力学指标。',
    tec9_txt: '核子密度仪',
    tec10_txt: '现场渗气检测',
    tec11_txt: '现场钻芯取样',
    tec12_txt: '沥青混凝土芯样',
    tec13_txt: '三轴实验设备',
    tec14_txt: '三轴试件',
    tec15_txt: '小梁弯曲试验仪',
    tec16_txt: '弯曲试件（试验前）',
    tec17_txt: '弯曲试件（试验后）',
    tec18_txt: '通过小梁弯曲试验得到沥青混凝土抗弯强度、最大弯拉应变、弯曲模量、挠跨比。',
    tec18_txt: '软化点试验仪'
  },
  news: {
    news1: '公司新闻',
    news2: '石门水库工程历时三年顺利完工',
    news3: '2010年5月，重庆玉滩水库扩建工程',
    news4: '行业新闻',
    news5: '环境保护部召开《重金属污染综合防治“十二五”规划》',
    news6: '石门水库工程历时三年顺利完工',
    news7: '发布时间',
    news8: '新疆呼图壁河石门水库于2010年破土动工，历时三年完工，地处新疆昌吉州呼图壁县的呼图壁河中上游峡谷进口段 ,东距乌鲁木齐市直线距离71ｋｍ ,北距呼图壁县直线距离 4 2ｋｍ。',
    news9: '石门水库是呼图壁河的骨干控制性水利工程工程总投资13.84亿，电站安装2*4075万千瓦，总装机容量9.5万千瓦，年发电量约2亿度，水库总长312.15米，最大高度106米，总库容7975万立方米。',
    news10: '工程以灌溉、防洪为主兼具发电，并具有拦沙减淤等综合利用效益，引水发电尾水渠与当地齐古水库尾水相接将从根本上解决农田灌溉、城市用水问题，可灌溉农田105.44万亩。并为灌溉区城镇工业和生活用水及近20多万人口引水安全提供水资源保障，可将下游呼图壁县的防洪标准提高到100年一遇，是完善呼图壁河流域防洪体系的重大工程。水库调节性能好，电站将承担乌昌电网调峰任务。',
    news11: '重庆玉滩水库扩建工程',
    news12: '2009年3月到2010年5月施工重庆玉滩水库。',
    news13: '玉滩水库扩建工程是拆除原大坝后，在原坝上游约40m处修建新的主坝。工程由枢纽和灌区两部分组成。玉滩水库扩建工程枢纽由主坝、7座副坝、溢洪道、左右岸灌溉引水隧洞及泵站组成，主坝坝型为沥青混凝土心墙坝，最大坝高42.70m，主坝总长688.20m,水库总库容1.496亿m3，设计灌溉面积30.13万亩，年引水总量（P=75%）8264万m3；城乡供水人口59.10万，城乡生活及工业年引水总量（P=95%）6100万m3。',
    news14: '环境保护部召开《重金属污染综合防治“十二五”规划》工作会议',
    news15: '环境保护部2月18日在京召开《重金属污染综合防治“十二五”规划》视频工作会议。环境保护部部长周生贤出席会议并讲话，他强调，要坚定不移贯彻落实中央决策部署，进一步加大工作力度，打好重金属污染防治攻坚战和持久战，切实维护人民群众利益和社会和谐稳定。',
    news16: '周生贤说，重金属污染防治，事关广大人民群众尤其是儿童的身体健康，事关社会的和谐稳定。国务院近日正式批复《重金属污染综合防治“十二五”规划》，这是我国第一个“十二五”专项规划，充分体现了党中央、国务院对重金属污染防治的高度重视。我们一定要抓住全面启动实施《规划》的契机，把思想认识统一到中央对重金属污染防治工作的决策部署上来，始终秉持民生为要、环保为民的理念，集中力量攻坚克难，不折不扣完成重点任务，全面遏制重金属污染事件高发态势，切实维护人民群众身体健康。',
    news17: '周生贤指出，《规划》遵循源头预防、过程阻断、清洁生产、末端治理的全过程综合防控理念，明确了重金属污染防治的目标，即到2015年，建立起比较完善的重金属污染防治体系、事故应急体系和环境与健康风险评估体系，解决一批损害群众健康的突出问题；进一步优化重金属相关产业结构，基本遏制住突发性重金属污染事件高发态势；重点区域重点重金属污染物排放量比2007年减少15％，非重点区域重点重金属污染物排放量不超过2007年水平，重金属污染得到有效控制。《规划》还从指导思想、基本原则、工作重点、主要任务、重点项目、政策保障和组织实施等方面提出一系列举措和要求，为当前和今后一段时期重金属污染防治工作指明了方向。',
    news18: '周生贤强调，各级环保部门要把重金属污染防治作为当前和今后一个时期环境保护的大事，全力以赴抓好《规划》实施的组织协调，抓住重点区域、重点行业和重点企业，健全法规标准体系，完善政策措施，依靠科技进步和严格执法监督，推动重金属污染防治工作取得成效。一要加强领导，落实责任。各省(区、市)政府是《规划》实施的主体，要切实加强组织领导，将《规划》确定的目标、任务和项目纳入本地区经济社会发展规划。要按照“一区一策”原则，编制各重点区域的重金属污染防治规划和年度实施方案，落实防治措施和资金。二要制定办法，严格考核。环境保护部将会同有关部门建立部门联动机制，研究制定《规划》实施情况考核办法，明确地方政府和相关部门责任，统筹推进《规划》实施。对《规划》实施达不到要求的地区，要严肃追究有关人员的责任。各地要把重金属污染防治成效纳入经济社会发展综合评价体系，并作为政府领导干部综合考核评价和企业负责人业绩考核的重要内容。三要突出重点，从严惩治。要把重金属污染防治作为今年九部门环保专项行动的重点，各地要加强对重金属污染企业，特别是工艺落后、污染严重的铅酸蓄电池、铅冶炼等企业的环境安全隐患认真进行排查，发现一个，解决一个，警示一片，坚决把污染隐患消灭在萌芽状态。对未进行环评和“三同时”验收的企业一律停产整改，对位于饮用水水源地的企业一律停产关闭，对污染治理设施不正常运行、长期超标排放的企业一律停产治理，对发现重大环境安全隐患的企业一律停产整改，对整改不到位的企业坚决予以关闭，对有环境劣迹的公司上市或再融资，两年内各级环保部门一律不得出具同意其通过上市核查的文件。四要源头防范，严格准入。科学调整重金属企业环境安全防护距离，禁止在重要生态功能区和因重金属污染导致环境质量不能稳定达标区域新建相关项目。组织好重点区域重金属产业发展规划、重点行业专项规划的环境影响评价，健全法规标准体系，并将其作为受理审批区域内重金属行业相关建设项目环境影响评价文件的前提。今后，凡没有完成淘汰落后产能任务的地区、重大污染导致群体性事件的地区，暂停其新增重点防控污染物排放的建设项目审批。五要妥善处置，维护稳定。各级环保部门要切实加强对重金属污染事件的信息报送工作，一旦发生问题，要及时报告，妥善处置，并协助地方政府做好信息公开、群众安抚和宣传教育工作，切实维护群众环境权益，保持社会和谐稳定。',
    news19: '环境保护部副部长张力军主持会议。',
    news20: '发展改革委、工业和信息化部、财政部、国土资源部、农业部、卫生部等部门，内蒙古自治区等14个重点省(区)的负责同志，各省、自治区、直辖市、新疆生产建设兵团环境保护厅(局)的主要负责同志，环境保护部有关司局、派出机构负责同志参加了会议。',



  },
  about: {
    about1: '公司文化',
    about2: '西安惠泽建设工程有限公司（简称西安惠泽）',
    about3: '成立于2010年6月20日，注册资本2000万元。公司主要从事水利水电工程土石坝沥青混凝土心墙施工。',
    about4: '公司具有雄厚的人才技术力量，精良的施工机械设备，先进的施工检测手段与完善的质量保证体系。',
    about5: '公司现有职工200余人，技术管理人员60人。其中高级职称10人，中级职称50人。公司资产总额达9000万元，',
    about6: ' 大中型施工机械50台套，其中沥青混凝土拌和楼16座，自主研发沥青混凝土心墙和面板联合摊铺机15台。',
    about7: ' 十年来，公司承接沥青防渗工程近80项，形成一支技术过硬、作风优良，善于攻坚克难的施工团队。',
    about8: '公司以独特的技术专业优势、丰富的施工经验、雄厚的施工实力、精湛的施工工艺在业内享有极高声誉。',
    about9: '公司业务以高新特色施工技术及其应用为主，不断加大对技术开发的投入，在专业化施工道路上取得了丰硕成果。',
    about10: '成功完成了重庆玉滩水库、四川去学水电站、新疆石门水电站、西藏恰央水库、',
    about11: '吉林敦化抽水蓄能电站上下库等70余座沥青混凝土防渗工程。',
    about12: '西安惠泽建设工程有限公司（简称西安惠泽）成立于2010年6月20日，注册资本2000万元。公司主要从事水利水电工程土石坝沥青混凝土心墙施工。',
    about13: '公司具有雄厚的人才技术力量，精良的施工机械设备，先进的施工检测手段与完善的质量保证体系。公司现有职工200余人，技术管理人员60人。其中高级职称10人，中级职称50人。公司资产总额达9000万元，大中型施工机械50台套，其中沥青混凝土拌和楼16座，自主研发沥青混凝土心墙和面板联合摊铺机15台。',
    about14: '十年来，公司承接沥青防渗工程近80项，形成一支技术过硬、作风优良，善于攻坚克难的施工团队。公司以独特的技术专业优势、丰富的施工经验、雄厚的施工实力、精湛的施工工艺在业内享有极高声誉。公司业务以高新特色施工技术及其应用为主，不断加大对技术开发的投入，在专业化施工道路上取得了丰硕成果。成功完成了重庆玉滩水库、四川去学水电站、新疆石门水电站、西藏恰央水库、吉林敦化抽水蓄能电站上下库等70余座沥青混凝土防渗工程。',
    about15: '公司宗旨：诚恳做人，踏实做事。',
    about16: '',
    about17: '公司原则：安全第一、质量为本。',
    about18: '公司理念：惠及天下、泽被桑梓。',
    about19: '公司愿景：国内一流专业工程公司。',
    about20: '',
    about21: '',
    about22: '',
    about23: '发展历程',
    about24: '西安惠泽建设工程有限公司成立正式进入沥青防渗工程领域； 完成库什塔依水电站项目沥青混凝土心墙施工，实现-15℃低温环境施工作业',
    about25: ' 完成世界已建最高沥青混凝土心墙土石坝（174.2m）去学水电站工程项目沥青混凝土心墙施工',
    about26: '完成中国第一座弧形轴线沥青混凝土心墙坝河心水库沥青混凝土心墙施工',
    about27: '完成国内沥青混凝土心墙方量最大土石坝沥青混凝土心墙施工，并研发出国内外最宽的沥青心墙联合摊铺机',
    about28: ' 完成玉滩水库沥青混凝土心墙施工，获得中国水利工程大禹奖、中国建设工程鲁班奖',
    about29: '完成国内坝址区海拔最高的沥青混凝土心墙坝恰央水库项目沥青混凝土心墙施工',
    about30: '完成海外沥青混凝土心墙坝项目宗格鲁水电站施工建设沥青混凝土心墙施工',
    about31: '资质证书',
    about32: '联系我们',
    about33: '提交',
    about121: '修建阿克肖河上唯一的控制性水库阿克肖水库的沥青混凝土心墙坝，心墙最大坝高近60m',
    about123: '完成新疆红山下水库大坝的修建，总库达996万m³',
    about120: '完成阳江抽水蓄能电站的修建，是国内已投运单机容量最大的抽水蓄能电站，机组设计难度位于世界前列',
    about122: '完成Ⅲ等中型工程雅砻水库，总库容为2206万m³',
    about201: '荣誉证书',
    about202: '获奖证书',
    about203: '参与起草',
  },
  nav:{
    logo:"../assets/image/logo.png"
  },
  contact: {
    con_1: '手机&微信',
    con_2: '电话',
    con_3: '邮箱',
    con_4: '地址',
    con_5: '西安市碑林区咸宁路9号 碧水云轩商住大厦',
    con_6: '标题',
    con_7: '姓名',
    con_8: '联系电话',
    con_9: '邮箱',
    con_10: '联系地址',
    con_11: '内容',
    message:'感谢您的留言，我们会尽快联络您',
    errorMessage:'请输入您的姓名和联系电话',
    errorTellMessage:'请输入正确的手机号',
    errorEmailMessage:'请输入您的邮箱',
    customerMessage:'客户留言',
    projectName:'项目名称',
    projectAddress:'项目地址'
  }



}
